package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebTextArea

@Composable
fun AdminTextArea(
    value: String,
    onChange: (String) -> Unit,
    placeholder: String = "",
    rows: Int = 4,
) {
    WebTextArea(
        value = value,
        onValueChange = onChange,
        placeholder = placeholder,
        rows = rows,
    )
}
